import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './hero8.css'

const Hero8 = (props) => {
  return (
    <div className="hero8-header26 thq-section-padding">
      <div className="hero8-max-width thq-section-max-width thq-flex-column">
        <div className="hero8-column">
          <div className="hero8-content">
            <h1>
              {props.heading1 ?? (
                <Fragment>
                  <h1 className="hero8-text3 thq-heading-1">
                    Welcome to the Commonwealth AI Consortium
                  </h1>
                </Fragment>
              )}
            </h1>
            <p>
              {props.content1 ?? (
                <Fragment>
                  <p className="hero8-text4 thq-body-large">
                    Empowering AI innovation across the Commonwealth
                  </p>
                </Fragment>
              )}
            </p>
            <div className="hero8-actions"></div>
          </div>
          <video
            src={props.videoSrc || "/video3.mp4"}
            controls
            className="hero8-video"
          >
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </div>
  )
}

Hero8.defaultProps = {
  heading1: undefined,
  content1: undefined,
  imageAlt: 'image',
}

Hero8.propTypes = {
  heading1: PropTypes.element,
  content1: PropTypes.element,
  imageAlt: PropTypes.string,
}

export default Hero8
